// based on https://www.electronjs.org/docs/latest/api/menu-item#new-menuitemoptions

export const Undo = 'undo'
export const Redo = 'redo'
export const Cut = 'cut'
export const Copy = 'copy'
export const Paste = 'paste'
export const PasteAndMatchStyle = 'pasteAndMatchStyle'
export const Delete = 'delete'
export const SelectAll = 'selectAll'
export const Reload = 'reload'
export const ForceReload = 'forceReload'
export const ToggleDevTools = 'toggleDevTools'
export const ResetZoom = 'resetZoom'
export const ZoomIn = 'zoomIn'
export const ZoomOut = 'zoomOut'
export const ToggleSpellChecker = 'toggleSpellChecker'
export const Togglefullscreen = 'togglefullscreen'
export const Window = 'window'
export const Minimize = 'minimize'
export const Close = 'close'
export const Help = 'help'
export const About = 'about'
export const Services = 'services'
export const Hide = 'hide'
export const HideOthers = 'hideOthers'
export const Unhide = 'unhide'
export const Quit = 'quit'
export const ShowSubstitutions = 'showSubstitutions'
export const ToggleSmartQuotes = 'toggleSmartQuotes'
export const ToggleSmartDashes = 'toggleSmartDashes'
export const ToggleTextReplacement = 'toggleTextReplacement'
export const StartSpeaking = 'startSpeaking'
export const StopSpeaking = 'stopSpeaking'
export const Zoom = 'zoom'
export const Front = 'front'
export const AppMenu = 'appMenu'
export const FileMenu = 'fileMenu'
export const EditMenu = 'editMenu'
export const ViewMenu = 'viewMenu'
export const ShareMenu = 'shareMenu'
export const RecentDocuments = 'recentDocuments'
export const ToggleTabBar = 'toggleTabBar'
export const SelectNextTab = 'selectNextTab'
export const SelectPreviousTab = 'selectPreviousTab'
export const MergeAllWindows = 'mergeAllWindows'
export const ClearRecentDocuments = 'clearRecentDocuments'
export const MoveTabToNewWindow = 'moveTabToNewWindow'
export const WindowMenu = 'windowMenu'
